import { render, staticRenderFns } from "./TheWorkspaceApp.vue?vue&type=template&id=be0cd1d0&"
import script from "./TheWorkspaceApp.vue?vue&type=script&lang=js&"
export * from "./TheWorkspaceApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports